import { Divider, SummaryInformationCategory } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { ITaxResidenceBase } from '@/store/models/taxResidence.model';

interface ITaxResidenceSummary {
  taxResidences?: ITaxResidenceBase[];
}

export function TaxResidenceSummary({ taxResidences = [] }: ITaxResidenceSummary) {
  const { t } = useTranslation();

  if (!taxResidences.some((taxResidence) => taxResidence.country)) return <>-</>;

  return (
    <>
      {taxResidences
        .filter((item) => item.country)
        .map((taxResidence, index) => (
          <>
            {index > 0 && <Divider />}
            <SummaryInformationCategory
              key={`taxResidenceSummary-${taxResidence.country}`}
              direction="row"
              items={[
                {
                  label: t('pages.currentProfiles.profile.taxResidence.country'),
                  value: t(`shared.countries.${taxResidence.country}`),
                },
                {
                  label: t('pages.currentProfiles.profile.taxResidence.taxPayerId'),
                  value: taxResidence.taxPayerId || '-',
                },
              ]}
            />
          </>
        ))}
    </>
  );
}
